module.exports = __webpack_public_path__ + "img/ktb.0f0a4cca.png";